<template>
  <div class="min-h-screen flex items-center justify-center p-4 bg-slate-50 dark:bg-slate-900">
    <div class="max-w-md w-full bg-white dark:bg-slate-800 rounded-3xl p-8 text-center shadow-xl border border-slate-200 dark:border-slate-700">
      <div class="w-20 h-20 bg-emerald-100 dark:bg-emerald-900/30 rounded-full flex items-center justify-center mx-auto mb-6">
        <Check class="w-10 h-10 text-emerald-500" />
      </div>

      <h1 class="text-2xl font-bold text-slate-900 dark:text-white mb-2">¡Pago Exitoso!</h1>
      <p class="text-slate-500 dark:text-slate-400 mb-8 text-sm">
        Tu pago ha sido procesado correctamente a través de PayPal. Tu suscripción ya ha sido actualizada y tienes 30 días de acceso ilimitado.
      </p>

      <router-link
        to="/client/billing"
        class="inline-flex items-center justify-center w-full py-3 px-4 rounded-xl bg-brand-500 hover:bg-brand-600 text-white font-bold transition-all"
      >
        Volver a mi Panel
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { Check } from 'lucide-vue-next';
// Opcional: Podrías hacer un apiClient.get('/get_my_subscription_status') aquí
// para actualizar SecureStorage y forzar a la app a saber que ya es Premium.
</script>